import React from 'react'
import classNames from 'classnames'

const Spinner = ({ color }) => {

	const spinnerClass = classNames(
		'spinner', {
			'spinner--primary': color === 'primary',
		}
	)

	return <div className={spinnerClass} />
}

export default Spinner;



// WEBPACK FOOTER //
// ./src/js/common/components/Spinner.js